import { Box, CircularProgress } from "@mui/material";
import { displayMediaObjectStyles } from "./displayMediaObjectStyle";
import { useEffect, useState } from "react";
import { MediaObject } from "../../types/MediaObject";
import { ExternalReferenceFile } from "../../types/ExternalReferenceFile";

export type DisplayImageMediaObjectProps = {
  mediaObject: MediaObject | ExternalReferenceFile["mediaObjects"][number];
  displayUrl: string;
  mediaRotation: number;
  initialPage?: number | null;
};

export default function DisplayMediaObjectContentPdf({
  mediaObject,
  displayUrl,
  mediaRotation,
  initialPage = null,
}: DisplayImageMediaObjectProps) {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
  }, [mediaObject]);

  return (
    <Box sx={displayMediaObjectStyles.embedContainer}>
      {isLoading && (
        <Box sx={displayMediaObjectStyles.loadingWrapper}>
          <CircularProgress />
        </Box>
      )}
      <embed
        onLoad={() => setIsLoading(false)}
        src={initialPage === null ? displayUrl : `${displayUrl.split("#")[0]}#page=${initialPage}`}
        type={mediaObject.mimeType!}
        width="100%"
        height="95%"
        style={{ transform: `rotate(${mediaRotation}deg)` }}
      />
    </Box>
  );
}
